import guid from "./guid";

export const LOCAL_ID_PREFIX = "local-";

const generateLocalId = () => `${LOCAL_ID_PREFIX}${guid()}`;

export default generateLocalId;
